export function useDebounce() {
  let timeout;

  function debounce(cb, time) {
    clearTimeout(timeout);
    timeout = setTimeout(cb, time);
  }

  function cancel() {
    clearTimeout(timeout);
    timeout = undefined;
  }

  return {
    debounce,
    cancel,
  };
}
